<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-cloud-space-fill`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M39 3a1 1 0 011 1v20.187A10.255 10.255 0 0035.202 23c-4.676 0-8.988 2.206-10.368 6.547C20.797 29.992 18 34.44 18 38.714a8.37 8.37 0 002.805 6.287L5 45a1 1 0 01-1-1V4a1 1 0 011-1h34zm-4.098 24c4.059 0 7.403 3.15 7.855 7.204C44.67 35.086 46 37.061 46 39.357c0 3.093-2.416 5.604-5.41 5.643H28.034C24.703 45 22 42.218 22 38.786c0-3.206 2.358-5.845 5.385-6.179C28.42 29.352 31.395 27 34.902 27zM19 19h-6a1 1 0 00-.993.883L12 20v2a1 1 0 00.883.993L13 23h6a1 1 0 00.993-.883L20 22v-2a1 1 0 00-1-1zm12-8H13a1 1 0 00-.993.883L12 12v2a1 1 0 00.883.993L13 15h18a1 1 0 00.993-.883L32 14v-2a1 1 0 00-1-1z"/></svg>
</template>
<script>

export default {
  name: 'IconCloudSpaceFill',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
